<div class="date-picker-cst">
  <mat-form-field [floatLabel]="'never'" class="mat-block">
    <input
      matInput readonly
      [ngbPopover]="tmplDateRangePicker" container="body" placement="auto"
      autoClose="outside"
      popoverClass="popover-fill-content" #popoverDatePicker="ngbPopover"
      type="text" [placeholder]="placeholder || 'Date'"
      [value]="getLabel | call: value: format: local"
    />
    <ng-template #tmplDateRangePicker>
      <app-date-range-picker
        [selection]="value"
        (selectionChange)="onChangeFilterDateRange($event); popoverDatePicker.close()"
        [local]="local"
        (click)="$event.stopPropagation()">
      </app-date-range-picker>
    </ng-template>
    <button *ngIf="value" mat-button matSuffix mat-icon-button aria-label="Clear" (click)="onChangeFilterDateRange(null)">
      <i class="far fa-times"></i>
    </button>
  </mat-form-field>
</div>
